document.querySelectorAll(".icon-text-effect").forEach((item) => {
  item.addEventListener("click", function (e) {
    if (e.target.closest(".text-effect-container-main")) {
      return; // Prevents the click from propagating to the parent element
    }
    let textContainer = this.querySelector(".text-effect-container-main");
    let icon = this.querySelector(".plus-icon");

    if (textContainer.style.maxHeight) {
      textContainer.style.maxHeight = null;
      textContainer.style.opacity = 0;
      textContainer.style.zIndex = null;
      icon.style.transform = "rotate(0deg)";
      textContainer.classList.remove("text-effect-container-main-active");
      document.body.style.overflowY = "initial"; // Restore scroll
    } else {
      document
        .querySelectorAll(".text-effect-container-main")
        .forEach((container) => {
          container.style.maxHeight = null;
          container.style.opacity = 0;
          container.style.zIndex = null;
          container.parentElement.querySelector(".plus-icon").style.transform =
            "rotate(0deg)";
          container.classList.remove("text-effect-container-main-active");
        });

      textContainer.style.maxHeight = textContainer.scrollHeight + "px";
      textContainer.style.opacity = 1;
      textContainer.style.zIndex = "1001";
      textContainer.classList.add("text-effect-container-main-active");
      icon.style.transform = "rotate(45deg)";
      document.body.style.overflowY = "hidden"; // Prevents scrolling when the text effect is active
    }
  });
});
